import {connect} from 'react-redux';

import {wrapActionCreator} from '../../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {Dispatch} from '../../../../store/appStore';
import {removeCommentReactionErrorAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getCommentReactionErrors} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {ReactionsBanners} from './reactionsBanners';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  reactionErrors: getCommentReactionErrors,
}));

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    removeCommentReactionError: wrapActionCreator(dispatch, removeCommentReactionErrorAction),
  };
}

export const ReactionsBannersContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps) => ({
    ...stateProps,
    onDismiss: (id: string) => {
      dispatchProps.removeCommentReactionError(id);
    },
  }),
)(ReactionsBanners);
